import { render } from "./ForgottenPassword.vue?vue&type=template&id=0ce9cf0c"
import script from "./ForgottenPassword.vue?vue&type=script&lang=js"
export * from "./ForgottenPassword.vue?vue&type=script&lang=js"
script.render = render

export default script